module.exports = __webpack_public_path__ + "static/media/md-swap.b230d50f.svg";